/*
These functions make sure WordPress
and Foundation play nice together.
*/


// Functions
(function( $ ){
	// Set data-venue on eventModal - used to route enquiry email and signup
	$('.eventEnquiry').on('click', function(event) {
		var currentTarget = $(event.currentTarget);

		$('#enquiryModal').data('venue', currentTarget.data('venue'));
	});

	$('#enquiryModal').on('closeme.zf.reveal', function(event) {
		var currentTarget = $(event.currentTarget);
		var venue = currentTarget.data('venue');

		// Set the modal forms hidden field to that of venue for conditional logic
		currentTarget.find('form input[name=input_19].gform_hidden').val(venue);

		// Replace 'Stokhouse' text with current venue name
		if (venue !== 'stokehouse') {
			var regexp = new RegExp('stokehouse', 'gi');
			var text = $('.gchoice_1_16_1 label').text();

			text = text.replace(regexp, venue.charAt(0).toUpperCase() + venue.slice(1));

			$('.gchoice_1_16_1 label').text(text);
		}

	});

	// Floating Form Field effect on Gravity Forms
   $.fn.focusFields = function() {

	  this.on('focus', function(){
		    $(this).closest('.gfield').addClass('is_focus');
		}).on('blur', function(){
		    if( !$(this).val() ) { //if it is blank.
		        $(this).closest('.gfield').removeClass('is_focus');
		    }
		});
		return this;

   };

   // Floating Form Field effect on Gravity Forms,
   // loop to check and refocus if need be. eg after GF error
   $.fn.focusFieldsLoop = function() {

		this.each(function() {
			if( $(this).val() ) { // if it has a value
	        $(this).closest('.gfield').addClass('is_focus');
	    }
		});
		return this;

   };


   // Swap Placeholder, used for signup form
   $.fn.swapPlaceholder = function() {

		this.on('focus', function(){
		    $(this).data('placeholder', $(this).attr('placeholder'));
		    $(this).attr('placeholder', $(this).attr('title'));
		}).on('blur', function(){
		    $(this).attr('placeholder', $(this).data('placeholder'));
		});
		return this;

   };


})( jQuery );



jQuery(document).ready(function($) {

	$(".animsition").animsition({
	    inClass: 'fade-in',
	    outClass: 'fade-out',
	    inDuration: 1000,
	    outDuration: 500,
	    //linkElement: '.menu-item a',
	    linkElement: 'a:not([target="_blank"]):not([href^="#"]):not(.no-fade):not(.ui-no-fade):not(.ui-datepicker-next):not(.ui-datepicker-prev):not(.ui-datepicker-calendar):not(.ui-datepicker-title)',
	    loading: true,
	    loadingParentElement: 'body', //animsition wrapper element
	    loadingClass: 'animsition-loading',
	    loadingInner: '', // e.g '<img src="loading.svg" />'
	    timeout: true,
	    timeoutCountdown: 5000,
	    onLoadEvent: true,
	    browser: [ 'animation-duration', '-webkit-animation-duration'],
	    // "browser" option allows you to disable the "animsition" in case the css property in the array is not supported by your browser.
	    // The default setting is to disable the "animsition" in a browser that does not support "animation-duration".
	    overlay : false,
	    overlayClass : 'animsition-overlay-slide',
	    overlayParentElement : 'body',
	    transition: function(url){ window.location.href = url; }
	  });





	$('#nav-toggle').click( function(e) {
		e.preventDefault();
	  $('body').toggleClass('menu_open');
	});


	$("figcaption").each(function( index ){
   $( this ).children().first().text( index + 1 ); // Started at 0, so + 1
   //console.log(index);
 	});



 	$("#js-reservations-close").click(function(e){
 		e.preventDefault();
   $( 'body' ).removeClass('reservations_active');
 	});

 	$("[href='#reservations']").click(function(e){
 		e.stopPropagation();
 		$( 'body' ).addClass('reservations_active');
 	});

  $(".mobile_nav [href='#contact']").on('click', function(e) {
//r

  	$('body').removeClass('menu_open');
    if (this.hash !== "") {
      e.preventDefault();
      var hash = this.hash;
      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 1000, function(){
        window.location.hash = hash;
      });
    }
	});


	$("[href='#contact']").on('click', function (e) {

		if (this.hash !== "") {
			e.preventDefault();
			var hash = this.hash;
			$('html, body').animate({
				scrollTop: $(hash).offset().top - 100
			}, 1000, function () {
				window.location.hash = hash;
			});
		}
	});

  $("[href='#enquiry']").on('click', function(e) {

    if (this.hash !== "") {
      e.preventDefault();
      var hash = this.hash;
      $('html, body').animate({
        scrollTop: $(hash).offset().top - 100
      }, 1000, function(){
        window.location.hash = hash;
      });
    }
  });

 	$("#js-reservations-box").click(function(e){
 		e.stopPropagation();
 	});

 	$(document.body).click( function(e) {
 		//console.log('clicked');
 		//e.stopPropagation();
 		$( this ).removeClass('reservations_active');
 	});



 	$(".breadcrumbs a[href^='#']").on('click', function(e) {

    if (this.hash !== "") {
      e.preventDefault();
      var hash = this.hash;
      $('html, body').animate({
        scrollTop: $(hash).offset().top - 140
      }, 1000, function(){
        window.location.hash = hash;
      });
    }
  });






	// Run functions
	$('input.js-placeholder-swap').swapPlaceholder();
	$('.gfield input, .gfield textarea').focusFields();




	// Detect scroll direction
	var lastScrollTop = 0;

	$(window).scroll( function(){

	   var st = $(this).scrollTop();
	   if (st > lastScrollTop){
	       $('html').attr('scroll-direction', 'down');
	   } else {
	       $('html').attr('scroll-direction', 'up');
	   }
	   lastScrollTop = st;

	});



	// Waypoints

	var waypointTop = $('body').waypoint({
	  handler: function(direction) {
	    if (direction === 'down') {
		   	$('html').attr('scroll-position', 'mid');
			} else if (direction === 'up') {
				$('html').attr('scroll-position', 'top');
			}
	  },
	  offset: -75
	})

	var waypointTop = $('.footer').waypoint({
	  handler: function(direction) {

	    if (direction === 'down') {
		   	$('html').attr('scroll-position', 'bottom');
			} else if (direction === 'up') {
				$('html').attr('scroll-position', 'mid');
			}
	  },
	  offset: 75
	});

	// var tickerInView = new Waypoint.Inview({
 //        element: $('.tickertape'),
 //        enter: function(direction) {
	// 	  	$('body').addClass('ticker-inview');
	// 	 },
	// 	entered: function(direction) {
	// 	},
	// 	exit: function(direction) {

	// 	},
	// 	exited: function(direction) {
	// 		console.log('b');
	// 		$('body').removeClass('ticker-inview');
	// 	}
 //    });

	/* var waypointBottom = $('body').waypoint({
	  handler: function(direction) {
	    if (direction === 'down') {
		   	$('html').attr('scroll-position', 'bottom');
			} else if (direction === 'up') {
				$('html').attr('scroll-position', 'mid');
			}
	  },
	  offset: function () {
    	return this.context.innerHeight() - this.adapter.outerHeight() + 75
  	}
	})

	*/


	$('.main img, .home_block__quote').each(function() {

			// maybe need to do imagesLoaded

			$(this).addClass('ready');

	    var inview = new Waypoint.Inview({
	        element: $(this),
	        enter: function(direction) {
				  	$(this[0,'element']).addClass('inview');
				  },
				  entered: function(direction) {
				  	//console.log('entered');
				  },
				  exit: function(direction) {

				  },
				  exited: function(direction) {
				  	//$(this[0,'element']).removeClass('inview');
				  }
	    });
	});



	$('.room, .enquiry').each(function() {
			/*
	    var inview = new Waypoint.Inview({
	        element: $(this),
	        enter: function(direction) {
				  	$(this[0,'element']).addClass('stuck');
				  },
				  entered: function(direction) {
				  	//console.log('entered');
				  },
				  exit: function(direction) {

				  },
				  exited: function(direction) {
				  	$(this[0,'element']).removeClass('stuck');
				  }
	    });
			*/

			var waypointTopHit = $(this).waypoint({
			  handler: function(direction) {
			    if (direction === 'down') {
				   	$(this[0,'element']).addClass('show');
					} else if (direction === 'up') {
						$(this[0,'element']).removeClass('show');
					}
			  },
			  offset: 105 + 100
			})


	    var waypointBottomHit = $(this).waypoint({
			  handler: function(direction) {
			    if (direction === 'down') {
				   	$(this[0,'element']).removeClass('show');
					} else if (direction === 'up') {
						$(this[0,'element']).addClass('show');
					}
			  },
			  offset: function () {
			    return this.context.innerHeight() - this.adapter.outerHeight() - 200
			  }
			})

	});




	// Packery Journal Archive

	// init Packery
	var $grid = $('.packery').packery({
	  itemSelector: '.packery__item',
	});
	// layout Packery after each image loads
	$grid.imagesLoaded().progress( function() {
	  $grid.packery();
	});


	// $('#popup').foundation('open');
	// var elem = new Foundation.Reveal('#test');


});



// Gravity forms post render callback

jQuery(document).bind('gform_post_render', function(){

    jQuery('.gfield input, .gfield textarea').focusFields();
    jQuery('.gfield input, .gfield textarea').focusFieldsLoop();

});

